import useStyles from './styles';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import React from 'react';
const JetDialog = (props : any) => {
    const classes = useStyles();
    const {
        className,
        ...otherProps
      } = props;   
    const classNames = [classes.jetDialog, className].join(' ');

    return <Dialog {...otherProps} className={classNames}>{props.children}</Dialog>
}


export default JetDialog